import {
  convertEventSelectToTarget,
  formatDataToLabelValue,
  FormFeedBack,
  locale,
  Select,
} from '@repo/ui';
import {
  GetAllGroupsUserUseCaseInterface,
  GetAllSemestersUserUseCaseInterface,
  GetAllCurricularUnitsUserUseCaseInterface,
} from 'domain/usecases';
import { FormikProps } from 'formik';
import { LegendsType } from 'presentation/app/hooks/useLegends';
import Flatpickr from 'react-flatpickr';
import { Col, Form, Input, Label, Row } from 'reactstrap';

interface IProps {
  getLegends: (key: keyof LegendsType, isPlural?: boolean) => any;
  validation: FormikProps<any>;
  filterBySemester: boolean;
  filterByCurricularUnit: boolean;
  groupsUser: GetAllGroupsUserUseCaseInterface.Result;
  semestersUser: GetAllSemestersUserUseCaseInterface.Result;
  curricularUnitsUser: GetAllCurricularUnitsUserUseCaseInterface.Result;
}

export const ProfessionalOverviewFilters = ({
  getLegends,
  validation,
  groupsUser,
  semestersUser,
  filterBySemester,
  curricularUnitsUser,
  filterByCurricularUnit,
}: IProps) => {
  return (
    <Form
      autoComplete="off"
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
        return false;
      }}
    >
      <Row>
        <Col md={6} lg={4} className="mb-3">
          <Label htmlFor="groups" className="form-label">
            {`${getLegends('GRUPO', true)}:`}
          </Label>
          <Select
            isClearable
            isMulti
            id="groups"
            name="groups"
            placeholder={`Todos os ${getLegends('GRUPO', true)}`}
            value={validation.values.groups}
            onChange={(e) => {
              validation.handleChange(convertEventSelectToTarget('groups', e));
            }}
            onBlur={validation.handleBlur}
            options={formatDataToLabelValue(groupsUser as never, 'id', 'nome')}
          />
          <FormFeedBack
            error={String(validation.errors?.groups)}
            isInvalid={!!(validation.touched && validation.errors?.groups)}
          />
        </Col>
        {filterBySemester && (
          <Col md={6} lg={4} className="mb-3">
            <Label htmlFor="semester" className="form-label">
              {`${getLegends('SEMESTRE', false)}:`}
            </Label>
            <Select
              isClearable
              id="semester"
              name="semester"
              placeholder={`Todos os ${getLegends('SEMESTRE', true)}`}
              value={validation.values.semester}
              onChange={(e) => {
                validation.handleChange(
                  convertEventSelectToTarget('semester', e),
                );
              }}
              onBlur={validation.handleBlur}
              options={formatDataToLabelValue(
                semestersUser as never,
                'id',
                'nome',
              )}
            />
            <FormFeedBack
              error={String(validation.errors?.semester)}
              isInvalid={!!(validation.touched && validation.errors?.semester)}
            />
          </Col>
        )}

        {filterByCurricularUnit && (
          <Col md={6} lg={4} className="mb-3">
            <Label htmlFor="curricularUnit" className="form-label">
              {`${getLegends('UNIDADE_CURRICULAR', false)}:`}
            </Label>
            <Select
              isClearable
              id="curricularUnit"
              name="curricularUnit"
              placeholder={`Todos os ${getLegends('UNIDADE_CURRICULAR', true)}`}
              value={validation.values.curricularUnit}
              onChange={(e) => {
                validation.handleChange(
                  convertEventSelectToTarget('curricularUnit', e),
                );
              }}
              onBlur={validation.handleBlur}
              options={formatDataToLabelValue(
                curricularUnitsUser as never,
                'id',
                'nome',
              )}
            />
            <FormFeedBack
              error={String(validation.errors?.curricularUnit)}
              isInvalid={
                !!(validation.touched && validation.errors?.curricularUnit)
              }
            />
          </Col>
        )}

        <Col md={6} lg={4} className="mb-3">
          <Label htmlFor="period" className="form-label">
            Período
          </Label>
          <div className="input-group">
            <div className="input-group-text">
              <i className="ri-calendar-2-line fs-14"></i>
            </div>
            <Input
              tag={Flatpickr}
              style={{ zIndex: 'auto' }}
              className="form-control cursor-pointer"
              options={{
                mode: 'range',
                dateFormat: 'd/m/Y',
                locale: locale,
              }}
              id="period"
              name="period"
              placeholder="Selecione o período"
              onBlur={validation.handleBlur}
              onChange={(selectedDates) => {
                validation.handleChange({
                  target: {
                    id: 'period',
                    name: 'period',
                    value: selectedDates,
                  },
                });
              }}
              value={validation.values.period}
              invalid={
                !!(validation.touched.period && validation.errors.period)
              }
            />
            <FormFeedBack
              error={String(validation.errors?.period)}
              isInvalid={!!(validation.touched && validation.errors?.period)}
            />
          </div>
        </Col>
      </Row>
    </Form>
  );
};
